<script module>
		import {protoActions, protoSkills, is_allowed, is_conform, are_enemies} from "../core.js";

		let placing = 'panel'   // 'panel' or 'map'
		let starting = $state(false)

		export class Option {
				action = ""     // actionID
				label = ""      // text for screen output (defaults to action)
				group = ""      // in which group is this option ('Aktionen', 'Reaktionen', 'Vorbereiten', 'Bewegungen', 'aktuelle Bewegung', 'Meister')
				aim = ""        // string representing the aim (will be sent to server)
				radius = 0
				loc = null      // location of the aim (for drawing on the map)
				action$ = null  // reference to action data
				execution = ""  // overrides data in action$ if specified
				exertion = 0
				kind = ""
				// specific attributes
				actID = 0       // for amending existing activities
				rank            // for appearance of new fighters

				constructor(action) {
						if (action in protoSkills) {
								const skill$ = protoSkills[action]
								this.action = skill$.name
								this.action$ = skill$
								this.skill = action
						} else {
								this.action = action
								this.action$ = protoActions[action]
						}
				}

				static compose_options(persona, location) {}

		}


		export function show_actionCard(option, place = 'panel', start = false, radius = 0) {
				const option$ = (typeof option === 'string') ? new Option(option) : option
				if (starting && view.option && view.option.action !== option$.action)		// there is another option currently marked as starting
						return
				if (radius > 0)
						option$.radius = radius
				console.log(`OPTIONDIALOG: ${(start) ? "start" : "show"} action card for option ${option$.action} at ${place}:`, {...option$})
				if (option$.action in protoActions && view.option?.action !== option$.action) {
						view.option = option$
						placing = place
						starting = (game.orders_possible) ? start ?? false : false
				} else if (option$.action === view.option?.action && start && game.orders_possible) {
						// console.log("Starting...")
						starting = true
				}
		}


		export function compose_options(persona, location) {
				if (!(persona && location))   return
		    let groupedOptions = {"Aktionen": [], "Reaktionen": [], "Bewegungen": [], "Vorbereiten": []}
		    /// show only Appear if fighter is not active or placed
		    if (!persona.position) {
		        location.map = view.map.ID
		        groupedOptions = {"Auftauchen": []}
		        const character = user.characters.get(persona.character)
		        if (character.isIndividuum)
		            groupedOptions["Auftauchen"].push({label: persona.name, action: 'Auftauchen', aim: location.toStr()})
		            // groupedOptions["Auftauchen"].push({instruct: 'APPEAR', label: persona.name, subject: persona.ID, target: location.toStr()})
		        else
		            for (let rank of Object.keys(character.ranks))
		                groupedOptions["Auftauchen"].push({instruct: 'APPEAR', label: rank, subject: persona.ID, target: location.toStr(), rank: rank})
				    console.log(`OPTIONDIALOG - options for ${persona.name} at ${location.toStr()}`, groupedOptions)
						return groupedOptions
		    }
		    /// if current activity is movement then insert special movement options
		    const currentAct = game.activities.get(persona.activity)
		    if (currentAct && ['Movement', 'Charge'].includes(currentAct.ZUB)) {
		        const aim = location.fgt ?? location.toStr()
		        groupedOptions["aktuelle Bewegung"] = [{label: "Wegpunkt", action: "INSERT", actID: persona.activity, aim: aim, kind: 'move'}]
		    }
		    /// add master only options
		    if (user.isMaster && !location.fgt)
		        groupedOptions["Meister"] = [{label: "Versetzen", instruct: 'TRANSFER', subject: persona.ID, target: location.toStr(), execution: 'proactive'}]
		    /// reduce options further
		    //ToDo: check distances
		    /** calculate aim
		     * - check if only position allowed
		     * - if fighter targeted, check affiliation and striking distance
		     * - else use position
		     *
		     ** check range modification and adjust label
		     * - Attack including running to
		     * - exponential rising difficulty, if distance > range
		     */
		    const options = (!persona.isStunned) ? persona.options : []
		    for (let action of options) {
		        const actionData = protoActions[action] ?? noAction
		        const aiming = actionData.aiming
		        let aim
		        if (!aiming || !aiming.repr || location.distance(persona.position) > 2 * actionData.dist + 1)
		            aim = null
		        else if (aiming.selfish)
		            aim = (view.persona.ID === location.fgt) ? view.persona.ID : false
		        else if (aiming.zone)
		            aim = (aiming.zone === 'Ctrl') ? location.fgt : (location.fgt && aiming.select) ? location.fgt : location.toStr()
		        else if (location.fgt && aiming.select && is_conform(aiming, view.persona.ID, location.fgt))
		            aim = location.fgt
		        else if ((aiming.select === 'pos' && !location.fgt) || aiming.select === 'loc' || aiming.zone)
		            aim = location.toStr()
		        else
		            aim = null
		        /// create option if aim is recognized
		        let exertion = (actionData.TYPE === 'Power') ? actionData.exertion : 0
		        const option = {action: action, aim: aim, kind: actionData.kind, execution: actionData.execution, exertion: exertion, aiming: actionData.aiming}
		        if (action in persona.cooldowns)
		            Object.assign(option, {label: `${action} (${persona.cooldowns[action] - game.time})`, disabled: true})
		        else if (actionData.acttype === 'Shoot') {
								const equipment = user.equipments.get(persona.equipment) ?? {}
								if (!(equipment.alloweds.includes('Shoot') && equipment.missile))
										continue
		        }
		        if (aim) {
		            if (actionData.acttype === 'Movement') {
	                  if (action === 'Schritt' && (!persona.activity || ['Movement', 'Charge'].includes(currentAct.ZUB)))
												continue
		                if (view.persona.ID !== location.fgt && is_allowed(action, persona.affects)) {
			                if (    ('CONCURRENT' in actionData.flags && !persona.concurrent && persona.activity) ||
				                    (!('CONCURRENT' in actionData.flags) && !persona.activity) ||
				                    ((action === "Schritt" && location.distance(persona.position) <= 3)) )
			                    groupedOptions["Bewegungen"].push(option)
	                    else if (!location.fgt && currentAct?.ZUB !== 'Movement')
			                    groupedOptions["Vorbereiten"].push(option)
		                }
		            } else if (actionData.ZUB === 'Reaction') {
				            if (!actionData.trigger)
						            groupedOptions["Reaktionen"].push(option)
		            } else if (action === "Waffe wechseln") {
		            } else {
		                if (location.distance(persona.position) > actionData.dist)
		                    option['diffclt'] = Math.round(location.distance(persona.position) / actionData.dist * 10) - 10
		                if (!persona.activity)
		                    groupedOptions["Aktionen"].push(option)
		                else
		                    groupedOptions["Vorbereiten"].push(option)
		            }
		        } else if (action === "Angriff" && !persona.activity && location.fgt && are_enemies( view.persona.ID, location.fgt))
		            groupedOptions["Aktionen"].push({action: action, label: "laufen + Angriff", aim: location.fgt, exertion: 0, kind: 'hurt', aiming: actionData.aiming})
		        else if (aiming.select === 'weap' && location.fgt === view.persona.ID  && view.persona.weapons.length > 1)
			        if ('Waffe' in groupedOptions)
						groupedOptions['Waffe'].push(option)
					else
						groupedOptions['Waffe'] = [option]
				else if (persona.activity && game.activities.get(persona.activity).ZUB === 'Movement' && actionData.ZUB !== 'Reaction' &&
		                 aiming.select === 'opp' && are_enemies(view.persona.ID, location.fgt))  // allow opponent attacks for preparation)
		            groupedOptions["Vorbereiten"].push(option)
		    }
		    /// remove all empty option groups
		    for (let [group, entries] of Object.entries(groupedOptions)) {
						if (entries.length === 0)  delete groupedOptions[group]
						entries.sort((opt1,opt2) => (opt1.exertion - opt2.exertion) || opt1.action.localeCompare(opt2.action))
				}
			    // console.log(`CORE - potential options for ${location.toStr()} are: `, groupedOptions)
		    return groupedOptions
		}


		export function close_actionCard(force = false) {
			// console.log('CLOSING', force)
			if (force instanceof MouseEvent) {
					force.stopPropagation()
					force = false
			}
			if (force || !starting) {
				// console.log(`OPTIONDIALOG: close action card ${view.option?.action}`)
				view.option = null
				starting = false
			}
		}

</script>


<!------------------------------- SCRIPT ------------------------------------->

<script>
  import { user, game, view } from "../client.svelte.js";
  import {onMount, tick} from "svelte";
  import {mapElement} from "../play/Encounter.svelte";
  import ActionCard from "../elements/ActionCard.svelte";
  import SkillCard from "../elements/SkillCard.svelte";

	let action = $derived(protoActions[view.option.action.trim()] ?? {})
	let abstract = "", effectText
	let cardDialog

	$inspect(`OPTION-DIALOG - ${(starting) ? "Starting" : "Showing"} action`, action)

	onMount( () => {
		// place card on screen
		console.log(`OPTIONDIALOG: ${(starting) ? "Start" : "Show"} action card for ${action.name} at ${placing}: `, {...action})
		if (starting && placing === 'map')
			cardDialog.showModal()
		else
			cardDialog.show()
		if (placing === 'map') {
			// ToDo: placing should take the card size correctly into account (without absolute positioning?)
			const mapRect = (mapElement) ? mapElement.getBoundingClientRect() : document.getElementsByTagName("main")[0].getBoundingClientRect()
			const cardRect = cardDialog.getBoundingClientRect()
			cardDialog.style.left = (mapRect.width / 2) // - document.getElementById("timeline")?.clientWidth ?? 0) / 2
															// + document.getElementsByTagName("header")[0].clientWidth
															- cardRect.width / 2 + "px"
			cardDialog.style.top = mapRect.height / 2 - cardRect.height / 2 + "px"
		} else if (placing === 'panel') {
			cardDialog.style.left = "8px"
			cardDialog.style.top = null
			cardDialog.style.bottom = "8px"
		} else {
			const mapRect = document.getElementsByTagName("main")[0].getBoundingClientRect()
			cardDialog.style.left = mapRect.width - 416 + "px"   // assuming card width equals side panel width
			// cardDialog.style.right = "16px"
			cardDialog.style.top = "16px"
			starting = false
		}
	})

  function _start_maneuver(risk) {
		// console.log(`OPTIONDIALOG - start maneuver`, view.option)
		if (placing === 'map')
				game.start_maneuver(action.name, risk, abstract)
	  else
				game.place_order({action: action.name, aim: view.option.aim})
		abstract = ""
	  view.close_dialog()
		close_actionCard(true)
	}
</script>


<!------------------------------- HTML ------------------------------------->

<dialog bind:this={cardDialog} id='option-dialog' data-help="actioncard" onclose={close_actionCard}>
  {#if action.name}
		{#if action.acttype === 'Performance' && action.skill in protoSkills}
			<SkillCard skill={protoSkills[action.skill]}/>
		{:else}
			<ActionCard action={action} />
		{/if}
		<span class="close" tabindex="0" onclick={() => cardDialog.close()}>&times;</span>
		{#if starting}
<!--			<Input type=submit value="x" class="close" tabindex="0" formmethod="dialog">&times;</Input>-->
			<input type="text" id=abstractInput class="text" bind:value={abstract} placeholder="Kurze Beschreibung der Handlung">
			{#if action.acttype === 'Performance'}
				<div id="abilityFooter" data-help="dice" class="cardFooter">
						{#each [2,3,4,5] as risk}
								<img class="skillBtns button icon" tabindex={risk-1} data-risk={risk}
										 src="/static/buttons/skill_{risk}dices.png" alt="{risk} W6*"
										 onclick={() => _start_maneuver(risk)}>
						{/each}
				</div>
			{:else}
				<img class="button icon d100" data-help="dice" tabindex="1" data-risk="1"
						 src="/static/buttons/fight_dices.png" alt="D100" title="Wurf auf Fertigkeit"
						 onclick={() => _start_maneuver()}/>
			{/if}
		{/if}
  {/if}
</dialog>


<!------------------------------- STYLES ------------------------------------->

<style lang="sass">
	#option-dialog
		z-index: 10
		position: absolute
		//width: 400px
		overflow: hidden
		font-family: 'EB Garamond', serif
		color: black
		margin: 8px
		break-inside: avoid

	.close
		position: absolute
		top: 8px
		right: 8px
		color: #aaaaaa
		float: right
		font-size: 28px
		font-weight: bold

	.close:hover
		color: #000
		text-decoration: none
		cursor: pointer

	.actionName
		margin: 0
		padding: 0.5em
		font-size: 150%

	.actionName.active
		font-style: normal
		text-decoration: none

	.actionName.proactive
		font-style: italic
		text-decoration: none

	.actionName.reactive
		font-style: normal
		text-decoration: underline

	.actionName.ultimative
		font-style: italic
		text-decoration: underline

	.domainsymbol
		position: absolute
		right: 8px
		top: 8px
		display: inline-block
		height: 4em
		width: 4em
		box-sizing: border-box
		box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)

	.inner
		margin: 0 1em
		padding: 4px

	.powerHeader
		display: grid
		grid-template-columns: 8ch auto
		padding: 8px
		font-weight: bolder

	.powerCoding
		white-space: pre-line

	.descript
		margin: 4px

	#abstractInput
		margin: 8px 15px 12px 15px
		width: calc(100% - 30px)

	.cardFooter
		display: flex
		justify-content: space-between
		gap: 24px
		padding: 0.5em 0.5em
		font-size: 150%

	#abilityFooter
		position: absolute
		bottom: 48px
		width: 80px
		left: 4px
		display: flex
		flex-wrap: wrap

	.powerExecution
		flex: 1
		text-align: left
		text-transform: capitalize
		font-weight: bold

	.powerExertion
		flex: 1
		text-align: center
		font-weight: bold

	.powerTerm
		flex: 1
		text-align: center
		font-weight: bold

	.powerTyped_progressiv
		background: linear-gradient(to top, white 0%, lightgray 100%) !important

	.d100
		position: absolute
		right: 8px
		bottom: 4px
</style>